import http, { streamFetch } from '@/shared/http';

class PragyaAiService {
  getAiResponse(data) {
    return http.post('/ai/ai_response', data);
  }
  getAiContentYoutube(data) {
    return http.post('/ai/get_ai_content/youtube', data);
  }
  getAiContentS3(data) {
    return http.post('/ai/get_ai_content/s3', data);
  }
  deleteAiContent(data) {
    return http.post('/ai/delete_ai_content', data);
  }
  getAllCourses() {
    return http.get('/ai/get_courses');
  }
  getAllModels() {
    return http.get('/ai/get_models');
  }
  /** OpenAI / Anthropic / Google (Vertex) + optional Ollama — from server llmModelCatalog. */
  getChatModelCatalog() {
    return http.get('/ai/chat_model_catalog');
  }
  customizeCourse(data) {
    return http.post('/ai/generate_course', data);
  }
  syncS3Namespaces() {
    return http.post('/ai/sync_s3_namespaces');
  }
  customizeCourseStream(data, onChunk, onDone, onError, signal) {
    return streamFetch(
      '/ai/course_resource',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
        signal,
      },
      onChunk,
      onDone,
      onError,
    );
  }
  generateYoutubeLinks(data) {
    return http.post('/ai/youtube', data);
  }
}

export default new PragyaAiService();
